import UpfrontIncentives from './UpfrontIncentives';
import BudgetItems from './BudgetItems';

const Budget = { UpfrontIncentives, BudgetItems };

export default Budget;